import structureTypes from '../constants/structureTypes'
import { PageTypeEnum } from './PageTypeEnum'

export enum EntityTypeEnum {
  InnerItem = 'InnerItem',
  Carousel = 'Carousel',
  CarouselItem = 'CarouselItem',
  Faq = 'Faq',
  FaqItem = 'FaqItem',
  PricePlanCalculator = 'PricePlanCalculator',
  WebinarRegistrationDate = 'WebinarRegistrationDate',
  Text = 'Text',
  TwitterTweetButton = 'TwitterTweetButton',
  Headline = 'Headline',
  CustomLogin = 'CustomLogin',
  CustomLoginForgotPassword = 'CustomLoginForgotPassword',
  BlogPostImage = 'BlogPostImage',
  ContentTable = 'ContentTable',
  Breadcrumbs = 'Breadcrumbs',
  ContactUs = 'ContactUs',
  Countdown = 'Countdown',
  ContentBox = 'ContentBox',
  TextArea = 'TextArea',
  Field = 'Field',
  Form = 'Form',
  Button = 'Button',
  WebsiteButton = 'WebsiteButton',
  LoginButton = 'LoginButton',
  RegistrationButton = 'RegistrationButton',
  ContactUsButton = 'ContactUsButton',
  Recaptcha = 'Recaptcha',
  Attachments = 'Attachments',
  OrderSummary = 'OrderSummary',
  BlogPostDate = 'BlogPostDate',
  BlogPostTitle = 'BlogPostTitle',
  Survey = 'Survey',
  UpsellAgreeButton = 'UpsellAgreeButton',
  UpsellDisagreeButton = 'UpsellDisagreeButton',
  Menu = 'Menu',
  BlogPostCategories = 'BlogPostCategories',
  Video = 'Video',
  Image = 'Image',
  BlogContentPlaceholder = 'BlogContentPlaceholder',
  BlogPostContentPlaceholder = 'BlogPostContentPlaceholder',
  BlogPostListing = 'BlogPostListing',
  LatestBlogPosts = 'LatestBlogPosts',
  HorizontalLine = 'HorizontalLine',
  BlogCategoryTitle = 'BlogCategoryTitle',
  BlogCategoryDescription = 'BlogCategoryDescription',
  Comments = 'Comments',
  WebinarSessionLink = 'WebinarSessionLink',
  WebinarSessionVideo = 'WebinarSessionVideo',
  WebinarSessionDateTime = 'WebinarSessionDateTime',
  OfferPrice = 'OfferPrice',
  LatestBlogPostsCarousel = 'LatestBlogPostsCarousel',
  OrderBump = 'OrderBump',
  ContactUsField = 'ContactUsField',
  Audio = 'Audio',
  Product = 'Product',
  WebinarCallToAction = 'WebinarCallToAction',
  SalesRedirectionButton = 'SalesRedirectionButton',
  FacebookComments = 'FacebookComments',
  OptInRecaptcha = 'OptInRecaptcha',
  //will be used instead of Recaptcha in the contact us form
  ContactUsRecaptcha = 'ContactUsRecaptcha',
  CustomerType = 'CustomerType',
  PaymentMethod = 'PaymentMethod',
  Row = 'Row',
  Column = 'Column',
  LanguageSwitcher = 'LanguageSwitcher',
  Section = 'Section',
  RawHtml = 'RawHtml',
  Checkbox = 'Checkbox',
  ShippingFees = 'ShippingFees',
  BulletList = 'BulletList',
  Coupon = 'Coupon',
  PaymentButton = 'PaymentButton',
  BookingCalendar = 'BookingCalendar',
  BookingPaidCalendar = 'BookingPaidCalendar',
  Agreement = 'Agreement',
  BookingCalendarPreview = 'BookingCalendarPreview', // only for the dashboard event's preview
  BookingCalendarReschedule = 'BookingCalendarReschedule', // only for the reschedule booking page
  InlineBody = 'InlineBody',
  BlogPageBody = 'BlogPageBody',
  BlogPostLayoutBody = 'BlogPostLayoutBody',
  RemotePopupBody = 'RemotePopupBody',
  Body = 'Body',
  BlogPostBody = 'BlogPostBody',
  Popup = 'Popup',
  PriceElement = 'PriceElement',

  TwoStepPaymentForm = 'TwoStepPaymentForm',
  TwoStepPaymentFormStepPayment = 'TwoStepPaymentFormStepPayment',
  TwoStepPaymentFormStepOptIn = 'TwoStepPaymentFormStepOptIn',
  SearchResults = 'SearchResults',
  Search = 'Search',

  // Website entities section
  WebsiteLayoutBody = 'WebsiteLayoutBody',
  WebsitePageBody = 'WebsitePageBody',
  WebsiteHeader = 'WebsiteHeader',
  WebsiteFooter = 'WebsiteFooter',
  WebsiteLogo = 'WebsiteLogo',
  WebsiteLogin = 'WebsiteLogin',
  WebsiteLanguageSwitcher = 'WebsiteLanguageSwitcher',
}

/**
 * Return type temporary is array, until inline is fully migrated
 * @param pageType
 */
export function getReadableRootEntityTypeByPageType(pageType: PageTypeEnum) {
  switch (pageType) {
    case PageTypeEnum.BlogHome:
    case PageTypeEnum.BlogPostListing:
    case PageTypeEnum.BlogStatic:
    case PageTypeEnum.BlogSearch:
      return [EntityTypeEnum.BlogPageBody, structureTypes.BLOG_PAGE_BODY]
    case PageTypeEnum.BlogPostBody:
      return [EntityTypeEnum.BlogPostBody, structureTypes.BLOG_POST_BODY]
    case PageTypeEnum.BlogPostLayout:
      return [
        EntityTypeEnum.BlogPostLayoutBody,
        structureTypes.BLOG_POST_LAYOUT_BODY,
      ]
    case PageTypeEnum.Inline:
      return [EntityTypeEnum.InlineBody]
    case PageTypeEnum.Popup:
      return [EntityTypeEnum.RemotePopupBody]
    case PageTypeEnum.WebsiteLayout:
    case PageTypeEnum.WebsiteHome:
    case PageTypeEnum.WebsiteDefault:
      return [EntityTypeEnum.WebsiteLayoutBody]
    case PageTypeEnum.WebsiteLogin:
    case PageTypeEnum.WebsitePricing:
      return [EntityTypeEnum.WebsitePageBody]
    default:
      return [EntityTypeEnum.Body, structureTypes.BODY]
  }
}

export default EntityTypeEnum
